import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import LogisticsConstants from "../../../../common/LogisticsConstants";

//Serivce

import FuelEntryModal from "./FuelEntryModal";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { formatDate } from "../../../../common/Validations";
import { useNavigate } from "react-router-dom";
import { addFuelData } from "../../../../redux/feature/logistics_app/logisticsSlice";
import CommonFilterCustomerV2 from "../../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";

const FuelEntryList = () => {
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Fuel History");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Fuel Entry List");

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // const [fuelList, setFuelList] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  let orderSchedulingData = useSelector(
    (state) => state?.customerV1?.order_scheduling,
  ); // User Details from Store
  let orderSchedulingTable = useSelector(
    (state) => state?.customerV1?.order_scheduling.pagination,
  ); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [data, setData] = useState();

  const handleCustomerRegister = (data) => {
    dispatch(addFuelData(data));
    navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_CREATE);
  };

  const fuelEntryInfo = [
    {
      name: "Fuel No",
      id: "documentNumber",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.documentNumber}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Truck Nr",
      id: "truckNo",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">{row?.truckNo}</p>
        </div>
      ),
      width: "120px",
    },

    {
      name: "Trip",
      selector: (row) => row.truckNo,
      cell: (row) => (
        <>
          {/* <span class="bg-table-status bg-table-new-status">{row.truckNo}</span> */}
          <button
            className="btnTable"
            onClick={() => handleCustomerRegister(row)}
          >
            Create
          </button>
        </>
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Filled Date",
      id: "filledDate",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">
            {formatDate(row?.filledDate)}{" "}
          </p>
        </div>
      ),
      width: "120px",
    },
    {
      name: "Bunk Name",
      id: "bunk",
      selector: (row) => row.bunk,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">{row.bunk} </p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Driver",
      id: "driverName",
      selector: (row) => row.driverName,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium">{row.driverName} </p>
          <p className="m-0 p-0 pt-1">{row.driverContactNr} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },

    // {
    //   name: "Driver Contact Nr",
    //   selector: (row) => row.driverContactNr,
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row.driverContactNr} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },
    {
      name: "Liters",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">{row.liters} </p>
        </div>
      ),
      selector: (row) => row.liters,
      sortable: true,
      width: "90px",
    },
    {
      name: "Total Amount(INR)",
      selector: (row) => row.totalAmount,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">{row.totalAmount} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Old Reading",
      selector: (row) => row.oldReading,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">{row.oldReading} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "New Reading",
      selector: (row) => row.newReading,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">{row.newReading} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Usage Reading",
      selector: (row) => row.usageReading,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium ">{row.usageReading} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Mileage",
      selector: (row) => Number(row.mileage).toFixed(2),
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium">
            {Number(row.mileage).toFixed(2)}
          </p>
        </div>
      ),
      sortable: true,
      width: "100px",
    },

    {
      name: "Attachments",
      selector: (row) => row.billDocument,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          {row.billDocument && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.billDocument)}
            />
          )}
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];

  const loadInitialSuuplierData = async () => {
    setData(orderSchedulingData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getFuelList",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };

    dispatch(getOrderSchedulingList(obj));
    setData(orderSchedulingData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getFuelList",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    setNewPerPage(newPerPage);
    dispatch(getOrderSchedulingList(obj));
    setData(orderSchedulingData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getFuelList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getOrderSchedulingList(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSchedulingData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getFuelList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getOrderSchedulingList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [modalFuelShowStatus, setmodalFuelShowStatus] = useState(false);

  /* show Cash request Modal Function */
  // eslint-disable-next-line
  const showFuelModal = () => {
    setmodalFuelShowStatus(true);
  };
  const hideModalStatus = () => {
    setmodalFuelShowStatus(false); //hide cash request modal
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getFuelList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getOrderSchedulingList(obj));
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Fuel Entry List</h2>
                <p className="subText">Fuel Entry List</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={fuelEntryInfo}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">FE</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Fuel Entry List</span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => showFuelModal()}
                      >
                        New Fuel Entry
                      </button>
                    </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={fuelEntryInfo}
                          data={data}
                          progressPending={orderSchedulingData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={orderSchedulingTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <FuelEntryModal
        show={modalFuelShowStatus}
        onHide={() => hideModalStatus()}
      />
    </main>
  );
};

export default FuelEntryList;
